

















import Vue, { VueConstructor } from 'vue'
import { notes, fromString, Note } from "@/application/models/notes";
import { majorScale, naturalMinorScale, harmonicMinorScale } from "@/application/models/scales";
import IconKey from '@/assets/icons/icon-key.svg'
import hasScaleInKey, { HasScaleInKeyMixinData } from '@/mixins/hasScaleInKey'
import hasEnharmonics, { HasEnharmonicsMixinData } from '@/mixins/hasEnharmonics'
import { setSelectedNote, setSelectedScale } from '@/application/KeyManager'

type Mixins = HasScaleInKeyMixinData & HasEnharmonicsMixinData

export default (Vue as VueConstructor<Mixins>).extend({
  name: "KeySelector",
  mixins: [hasScaleInKey, hasEnharmonics],
  components: {
    IconKey
  },
  data() {
    return {
      notes: notes,
      scales: [majorScale, naturalMinorScale, harmonicMinorScale]
    }
  },
  methods: {
    selectNote(note: string) {
      const noteObj = fromString(note)
      if (noteObj) {
        setSelectedNote(this.$route, this.$router, noteObj as Note)
      } else {
        console.error(`${note} is not a valid note`)
      }
    },
    selectScale(scaleName: string) {
      setSelectedScale(this.$route, this.$router, this.scales.find(s => s.name === scaleName))
    }
  }
})
